import { cn } from '@/utils';

function Label({ className, children, ...props }) {
	return (
		<label
			className={cn(
				'mb-2 block text-xs font-semibold leading-[20px] text-black',
				className
			)}
			{...props}
		>
			{children}
		</label>
	);
}

export default Label;
